import { createReducer, on } from '@ngrx/store';
import { Onboarding, OnboardingFailure, OnboardingSuccess, Register, RegisterFailure, RegisterSuccess, changePassword, changePasswordFailure, changePasswordSuccess, forgotPassword, forgotPasswordFailure, forgotPasswordSuccess, login, loginFailure, loginSuccess, logout, resetPassword, resetPasswordFailure, resetPasswordSuccess, updateUserProfile, updateUserProfileFailure, updateUserProfileSuccess } from './authentication.actions';
import { User } from '../../core/models/user.models';

export interface AuthenticationState {
    isLoggedIn: boolean;
    user: User | null;
    error: string | null;
    isRegisterSuccessful: boolean;
    success: User | null;
    isSuccess: boolean;
    loading: boolean;
}

const initialState: AuthenticationState = {
    isLoggedIn: false,
    user: null,
    error: null,
    isRegisterSuccessful: false,
    success: null,
    isSuccess: false,
    loading: false
};

export const authenticationReducer = createReducer(
    initialState,
    on(Register, (state) => ({ ...state, error: null, loading: true })),
    on(RegisterSuccess, (state) => ({ ...state, isLoggedIn: false, error: null, isRegisterSuccessful: true, loading: false})),
    on(RegisterFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(login, (state) => ({ ...state, error: null, loading: true })),
    on(loginSuccess, (state, { result }) => ({ ...state, isLoggedIn: true, result, error: null, loading: false})),
    on(loginFailure, (state, { error }) => ({ ...state, error, loading: false })),
    on(logout, (state) => ({ ...state, user: null })),

    on(forgotPassword, (state) => ({ ...state, error: null, loading: true})),
    on(forgotPasswordSuccess, (state, { success }) => ({ ...state, success, isSuccess: true, loading: false})),
    on(forgotPasswordFailure, (state, { error })=> ({ ...state, error, loading: false })),

    on(resetPassword, (state) => ({ ...state, error: null, loading: true })),
    on(resetPasswordSuccess, (state, { success }) => ({ ...state, success, isSuccess: true, user: null, loading: false})),
    on(resetPasswordFailure, (state, { error })=> ({ ...state, error, loading: false })),

    on(changePassword, (state) => ({ ...state, error: null, loading: true })),
    on(changePasswordSuccess, (state, { success }) => ({ ...state, success, isSuccess: true, loading: false})),
    on(changePasswordFailure, (state, { error })=> ({ ...state, error, loading: false })),

    on(Onboarding, (state) => ({ ...state, error: null, user: null, loading: true })),
    on(OnboardingSuccess, (state, { user }) => ({ ...state, isLoggedIn: true, user, error: null, isSuccess: true, loading: false})),
    on(OnboardingFailure, (state, { error }) => ({ ...state, error, user: null, loading: false })),

    on(updateUserProfile, (state) => ({ ...state, error: null, user: null, loading: true })),
    on(updateUserProfileSuccess, (state, { user }) => ({ ...state, isLoggedIn: true, user, error: null, isSuccess: true, loading: false})),
    on(updateUserProfileFailure, (state, { error }) => ({ ...state, error, user: null, loading: false })),

);
